import React, { useEffect } from "react";
import QuestionMark from "../../assets/images/question-mark.png";
import { useNavigate } from "react-router-dom";
import "./content.css";

export default function WelcomeContent({
  steps_completed,
  first_name,
  last_name,
  company_name,
  phone_number_verified,
  email_verified,
  verify_liveness,
  verify_fetch_match,
  aml_and_pep_check,
  status,
  identity,
  statusColor,
  kycType,
  jwttokenForBiometric,

  questionaire_data,
}) {
  let allCompleted = true;
  let anyPending = false;

  for (let obj of questionaire_data) {
    if (obj.is_completed) {
      anyPending = true;
    } else {
      allCompleted = false;
    }
  }

  return (
    <div className="nk-content nk-content-lg nk-content-fluid">
      <div className="container-xl wide-lg">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block-head nk-block-head-lg wide-xs mx-auto">
              <div className="nk-block-head-content text-center">
                <h2 className="nk-block-title fw-normal">
                  Welcome, {first_name} {last_name}
                </h2>
                <div className="nk-block-des">
                  {steps_completed != "kyc" ? (
                    <p>
                      Welcome to your <strong>{company_name} Dashboard.</strong>{" "}
                      You are a few steps away from completing your KYC/AML
                      check for your profile.
                    </p>
                  ) : (
                    <p>
                      Welcome to your <strong>{company_name} Dashboard.</strong>
                      . You've gone through the onboarding process. Please see
                      your status below. If you are currently pending or
                      rejected, click continue to raise your status to approved.
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="nk-block">
              <div className="card card-custom-s1 card-bordered">
                <div className="row no-gutters">
                  <div className="col-lg-4">
                    <div className="card-inner-group">
                      <div className="card-inner">
                        <h5>Let’s Finish Registration</h5>
                        <p>
                          Only few minutes required to complete your
                          registration and set up your account.
                        </p>
                      </div>
                      <div className="card-inner">
                        <ul className="list list-step">
                          {phone_number_verified == true ? (
                            <li className="list-step-done">
                              Verify Phone Number
                            </li>
                          ) : phone_number_verified == false ? (
                            <li className="list-step-notmatch">
                              Verify Phone Number
                              <em className="icon ni ni-cross-sm"></em>
                            </li>
                          ) : (
                            <li className="list-step-unknown">
                              Verify Phone Number
                              <img src={QuestionMark} />
                            </li>
                          )}

                          {email_verified ? (
                            <li className="list-step-done">
                              Verify Email Address
                            </li>
                          ) : (
                            <li className="list-step-unknown">
                              Verify Email Address
                              <img src={QuestionMark} />
                            </li>
                          )}

                          {kycType == "kycwithliveness" ? (
                            verify_liveness == true ? (
                              <li className="list-step-done">
                                Verify Liveness
                              </li>
                            ) : verify_liveness == false ? (
                              <li className="list-step-notmatch">
                                Verify Liveness
                                <em className="icon ni ni-cross-sm"></em>
                              </li>
                            ) : (
                              <li className="list-step-unknown">
                                Verify Liveness
                                <img src={QuestionMark} />
                              </li>
                            )
                          ) : null}

                          {(kycType == "kycwithliveness" ||
                            kycType == "kycwithselfie") &&
                          verify_fetch_match == true ? (
                            <li className="list-step-done">
                              Verify Face Match
                            </li>
                          ) : verify_fetch_match == false ? (
                            <li className="list-step-notmatch">
                              Verify Face Match
                              <em className="icon ni ni-cross-sm"></em>
                            </li>
                          ) : (
                            <li className="list-step-unknown">
                              Verify Face Match
                              <img src={QuestionMark} />
                            </li>
                          )}

                          {aml_and_pep_check == true ? (
                            <li className="list-step-done">
                              Verify AML and PEP
                            </li>
                          ) : aml_and_pep_check == false ? (
                            <li className="list-step-notmatch">
                              Verify AML and PEP
                              <em className="icon ni ni-cross-sm"></em>
                            </li>
                          ) : (
                            <li className="list-step-unknown">
                              Verify AML and PEP
                              <img src={QuestionMark} />
                            </li>
                          )}

                          {questionaire_data.length > 0 &&
                            (allCompleted ? (
                              <li className="list-step-done">
                                Compliance Questionnaire
                              </li>
                            ) : anyPending == false ? (
                              <li className="list-step-notmatch">
                                Compliance Questionnaire
                                <em className="icon ni ni-alert-circle"></em>
                              </li>
                            ) : (
                              <li className="list-step-unknown">
                                Compliance Questionnaire
                                <img src={QuestionMark} />
                              </li>
                            ))}
                        </ul>
                      </div>
                      <div className="card-inner">
                        <div className="align-center gx-3"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="card-inner card-inner-lg h-100">
                      <div className="align-center flex-wrap flex-md-nowrap g-3 h-100">
                        <div className="nk-block-image w-200px flex-shrink-0 order-first order-md-last">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 114 113.9"
                          >
                            <path
                              d="M87.84,110.34l-48.31-7.86a3.55,3.55,0,0,1-3.1-4L48.63,29a3.66,3.66,0,0,1,4.29-2.8L101.24,34a3.56,3.56,0,0,1,3.09,4l-12.2,69.52A3.66,3.66,0,0,1,87.84,110.34Z"
                              transform="translate(-4 -2.1)"
                              fill="#c4cefe"
                            />
                            <path
                              d="M33.73,105.39,78.66,98.1a3.41,3.41,0,0,0,2.84-3.94L69.4,25.05a3.5,3.5,0,0,0-4-2.82L20.44,29.51a3.41,3.41,0,0,0-2.84,3.94l12.1,69.11A3.52,3.52,0,0,0,33.73,105.39Z"
                              transform="translate(-4 -2.1)"
                              fill="#c4cefe"
                            />
                            <rect
                              x="22"
                              y="17.9"
                              width="66"
                              height="88"
                              rx="3"
                              ry="3"
                              fill="#6576ff"
                            />
                            <rect
                              x="31"
                              y="85.9"
                              width="48"
                              height="10"
                              rx="1.5"
                              ry="1.5"
                              fill="#fff"
                            />
                            <rect
                              x="31"
                              y="27.9"
                              width="48"
                              height="5"
                              rx="1"
                              ry="1"
                              fill="#e3e7fe"
                            />
                            <rect
                              x="31"
                              y="37.9"
                              width="23"
                              height="3"
                              rx="1"
                              ry="1"
                              fill="#c4cefe"
                            />
                            <rect
                              x="59"
                              y="37.9"
                              width="20"
                              height="3"
                              rx="1"
                              ry="1"
                              fill="#c4cefe"
                            />
                            <rect
                              x="31"
                              y="45.9"
                              width="23"
                              height="3"
                              rx="1"
                              ry="1"
                              fill="#c4cefe"
                            />
                            <rect
                              x="59"
                              y="45.9"
                              width="20"
                              height="3"
                              rx="1"
                              ry="1"
                              fill="#c4cefe"
                            />
                            <rect
                              x="31"
                              y="52.9"
                              width="48"
                              height="3"
                              rx="1"
                              ry="1"
                              fill="#e3e7fe"
                            />
                            <rect
                              x="31"
                              y="60.9"
                              width="23"
                              height="3"
                              rx="1"
                              ry="1"
                              fill="#c4cefe"
                            />
                            <path
                              d="M98.5,116a.5.5,0,0,1-.5-.5V114H96.5a.5.5,0,0,1,0-1H98v-1.5a.5.5,0,0,1,1,0V113h1.5a.5.5,0,0,1,0,1H99v1.5A.5.5,0,0,1,98.5,116Z"
                              transform="translate(-4 -2.1)"
                              fill="#9cabff"
                            />
                            <path
                              d="M16.5,85a.5.5,0,0,1-.5-.5V83H14.5a.5.5,0,0,1,0-1H16V80.5a.5.5,0,0,1,1,0V82h1.5a.5.5,0,0,1,0,1H17v1.5A.5.5,0,0,1,16.5,85Z"
                              transform="translate(-4 -2.1)"
                              fill="#9cabff"
                            />
                            <path
                              d="M7,13a3,3,0,1,1,3-3A3,3,0,0,1,7,13ZM7,8a2,2,0,1,0,2,2A2,2,0,0,0,7,8Z"
                              transform="translate(-4 -2.1)"
                              fill="#9cabff"
                            />
                            <path
                              d="M113.5,71a4.5,4.5,0,1,1,4.5-4.5A4.51,4.51,0,0,1,113.5,71Zm0-8a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,113.5,63Z"
                              transform="translate(-4 -2.1)"
                              fill="#9cabff"
                            />
                            <path
                              d="M107.66,7.05A5.66,5.66,0,0,0,103.57,3,47.45,47.45,0,0,0,85.48,3h0A5.66,5.66,0,0,0,81.4,7.06a47.51,47.51,0,0,0,0,18.1,5.67,5.67,0,0,0,4.08,4.07,47.57,47.57,0,0,0,9,.87,47.78,47.78,0,0,0,9.06-.87,5.66,5.66,0,0,0,4.08-4.09A47.45,47.45,0,0,0,107.66,7.05Z"
                              transform="translate(-4 -2.1)"
                              fill="#2ec98a"
                            />
                            <path
                              d="M100.66,12.81l-1.35,1.47c-1.9,2.06-3.88,4.21-5.77,6.3a1.29,1.29,0,0,1-1,.42h0a1.27,1.27,0,0,1-1-.42c-1.09-1.2-2.19-2.39-3.28-3.56a1.29,1.29,0,0,1,1.88-1.76c.78.84,1.57,1.68,2.35,2.54,1.6-1.76,3.25-3.55,4.83-5.27l1.35-1.46a1.29,1.29,0,0,1,1.9,1.74Z"
                              transform="translate(-4 -2.1)"
                              fill="#fff"
                            />
                          </svg>
                        </div>
                        <div className="nk-block-content">
                          <StepsCompletedText
                            status={status}
                            face_match={verify_fetch_match}
                            steps_completed={steps_completed}
                            identity={identity}
                            verify_liveness={verify_liveness}
                            statusColor={statusColor}
                            kycType={kycType}
                            jwttokenForBiometric={jwttokenForBiometric}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-block">
              <div className="card card-bordered">
                <div className="card-inner card-inner-lg">
                  <div className="align-center flex-wrap flex-md-nowrap g-4">
                    <div className="nk-block-image w-120px flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 120 118"
                      >
                        <path
                          d="M8.916,94.745C-.318,79.153-2.164,58.569,2.382,40.578,7.155,21.69,19.045,9.451,35.162,4.32,46.609.676,58.716.331,70.456,1.845,84.683,3.68,99.57,8.694,108.892,21.408c10.03,13.679,12.071,34.71,10.747,52.054-1.173,15.359-7.441,27.489-19.231,34.494-10.689,6.351-22.92,8.733-34.715,10.331-16.181,2.192-34.195-.336-47.6-12.281A47.243,47.243,0,0,1,8.916,94.745Z"
                          transform="translate(0 -1)"
                          fill="#f6faff"
                        />
                        <rect
                          x="18"
                          y="32"
                          width="84"
                          height="50"
                          rx="4"
                          ry="4"
                          fill="#fff"
                        />
                        <rect
                          x="26"
                          y="44"
                          width="20"
                          height="12"
                          rx="1"
                          ry="1"
                          fill="#e5effe"
                        />
                        <rect
                          x="50"
                          y="44"
                          width="20"
                          height="12"
                          rx="1"
                          ry="1"
                          fill="#e5effe"
                        />
                        <rect
                          x="74"
                          y="44"
                          width="20"
                          height="12"
                          rx="1"
                          ry="1"
                          fill="#e5effe"
                        />
                        <rect
                          x="38"
                          y="60"
                          width="20"
                          height="12"
                          rx="1"
                          ry="1"
                          fill="#e5effe"
                        />
                        <rect
                          x="62"
                          y="60"
                          width="20"
                          height="12"
                          rx="1"
                          ry="1"
                          fill="#e5effe"
                        />
                        <path
                          d="M98,32H22a5.006,5.006,0,0,0-5,5V79a5.006,5.006,0,0,0,5,5H52v8H45a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H73a2,2,0,0,0,2-2V94a2,2,0,0,0-2-2H66V84H98a5.006,5.006,0,0,0,5-5V37A5.006,5.006,0,0,0,98,32ZM73,94v4H45V94Zm-9-2H54V84H64Zm37-13a3,3,0,0,1-3,3H22a3,3,0,0,1-3-3V37a3,3,0,0,1,3-3H98a3,3,0,0,1,3,3Z"
                          transform="translate(0 -1)"
                          fill="#798bff"
                        />
                        <path
                          d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z"
                          transform="translate(0 -1)"
                          fill="#6576ff"
                        />
                        <path
                          d="M61.444,41H40.111L33,48.143V19.7A3.632,3.632,0,0,1,36.556,16H61.444A3.632,3.632,0,0,1,65,19.7V37.3A3.632,3.632,0,0,1,61.444,41Z"
                          transform="translate(0 -1)"
                          fill="none"
                          stroke="#6576ff"
                          strokeMiterlimit="10"
                          strokeWidth="2"
                        />
                        <line
                          x1="40"
                          y1="22"
                          x2="57"
                          y2="22"
                          fill="none"
                          stroke="#fffffe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                        <line
                          x1="40"
                          y1="27"
                          x2="57"
                          y2="27"
                          fill="none"
                          stroke="#fffffe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                        <line
                          x1="40"
                          y1="32"
                          x2="50"
                          y2="32"
                          fill="none"
                          stroke="#fffffe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                        <line
                          x1="30.5"
                          y1="87.5"
                          x2="30.5"
                          y2="91.5"
                          fill="none"
                          stroke="#9cabff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="28.5"
                          y1="89.5"
                          x2="32.5"
                          y2="89.5"
                          fill="none"
                          stroke="#9cabff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="79.5"
                          y1="22.5"
                          x2="79.5"
                          y2="26.5"
                          fill="none"
                          stroke="#9cabff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="77.5"
                          y1="24.5"
                          x2="81.5"
                          y2="24.5"
                          fill="none"
                          stroke="#9cabff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="90.5"
                          cy="97.5"
                          r="3"
                          fill="none"
                          stroke="#9cabff"
                          strokeMiterlimit="10"
                        />
                        <circle
                          cx="24"
                          cy="23"
                          r="2.5"
                          fill="none"
                          stroke="#9cabff"
                          strokeMiterlimit="10"
                        />
                      </svg>
                    </div>
                    <div className="nk-block-content">
                      <div className="nk-block-content-head px-lg-4">
                        <h5>We’re here to help you!</h5>
                        <p className="text-soft">
                          Ask a question or file a support ticket, manage
                          request, report an issues. Our team support team will
                          get back to you by email.
                        </p>
                      </div>
                    </div>
                    <div className="nk-block-content flex-shrink-0">
                      <a
                        href="https://support.kycaml.tech/"
                        className="btn btn-lg btn-outline-primary"
                      >
                        Get Support Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function StepsCompletedText({
  status,
  identity,
  face_match,
  statusColor,
  steps_completed,
  kycType,
  jwttokenForBiometric,
  verify_liveness,
}) {
  const navigate = useNavigate();

  const navigateToBiometric = () => {
    localStorage.setItem("biometric_reload", true);
    navigate("/onboarding", { state: { formType: "/biometric" } });
  };

  if (steps_completed == "all") {
    //chck for liveness fail
    // TODO: limit to 2
    if (verify_liveness != true && kycType == "kycwithliveness") {
      return (
        <>
          <p>
            <b>
              Your current onboarding status is
              <span
                style={{
                  marginLeft: "0.5rem",
                  marginRight: "0.2rem",
                  marginBottom: "0.5rem",
                }}
                className={
                  "badge badge-dim badge-sm badge-outline-" + statusColor
                }
              >
                {status}
              </span>
              . Your liveness test has failed, you can retry{" "}
              {/* up to {attemptLeft} times */} by clicking on the continue
              button.
            </b>
          </p>
          <a
            style={{ marginTop: "1rem" }}
            id="get_started_button"
            onClick={navigateToBiometric}
            className="btn btn-lg btn-primary"
          >
            Continue
          </a>
        </>
      );
    }
    //TODO: limit to 2 attempts
    if (kycType == "kycwithselfie" && face_match != true) {
      return (
        <>
          <p>
            <b>
              Your current onboarding status is
              <span
                style={{
                  marginLeft: "0.5rem",
                  marginRight: "0.2rem",
                  marginBottom: "0.5rem",
                }}
                className={
                  "badge badge-dim badge-sm badge-outline-" + statusColor
                }
              >
                {status}
              </span>
              . Your face match has failed.
            </b>
          </p>
          <a
            style={{ marginTop: "1rem" }}
            id="get_started_button"
            onClick={navigateToBiometric}
            className="btn btn-lg btn-primary"
          >
            Continue
          </a>
        </>
      );
    }
  }
  if (!steps_completed) {
    return (
      <>
        <div className="nk-block-content-head">
          <h4>Complete Your Onboarding</h4>
        </div>
        <p>
          Looks like your have not verified your identity. Please have your
          government ID ready to verify to get full access to the platform.
        </p>
        <ul className="list list-sm list-checked">
          <li>Worldwide Passport</li>
          <li>Worldwide National IDs</li>
          <li>U.S. Drivers Licenses</li>
        </ul>
        <a
          onClick={() => navigate("/verification")}
          id="get_started_button"
          className="btn btn-lg btn-primary"
        >
          Get Started
        </a>
      </>
    );
  }

  if (steps_completed == "verificationFormAndGetImage") {
    return (
      <>
        <div className="nk-block-content-head">
          <h4>Welcome Back! </h4>
        </div>
        <p>
          You are almost done with your onboarding. Please click the continue
          button to finish your Liveness Test and complete your KYC.
        </p>
        <ul className="list list-sm list-checked">
          <li>Worldwide Passport</li>
          <li>Worldwide National IDs</li>
          <li>U.S. Drivers Licenses</li>
        </ul>
        <a
          onClick={navigateToBiometric}
          id="get_started_button"
          className="btn btn-lg btn-primary"
        >
          Continue
        </a>
      </>
    );
  }
  if (steps_completed == "verificationForm") {
    return (
      <>
        <div className="nk-block-content-head">
          <h4>Welcome Back! </h4>
        </div>
        <p>
          You didn’t get far on your onboarding. Please click the continue
          button to start the process. You will need to finish uploading
          personal information and government ID to complete your KYC or KYB.
        </p>
        <ul className="list list-sm list-checked">
          <li>Worldwide Passport</li>
          <li>Worldwide National IDs</li>
          <li>U.S. Drivers Licenses</li>
        </ul>
        <a
          onClick={() => navigate("/verification")}
          id="get_started_button"
          className="btn btn-lg btn-primary"
        >
          Continue
        </a>
      </>
    );
  }

  return (
    <div className="nk-block-content-head">
      <h4>You’re finished! </h4>
      <p>
        You are now done with KYC check. Your AML and PEP check is ongoing and
        results will show when they are done. Your current onboarding status is
        <span
          style={{
            marginLeft: "0.5rem",
            marginRight: "0.2rem",
            marginBottom: "0.5rem",
          }}
          className={"badge badge-dim badge-sm badge-outline-" + statusColor}
        >
          {status}
        </span>
        . If you have any questions on your results, please reach out to
        customer support or your system administrator.{" "}
      </p>
    </div>
  );
}
